var map = {
	"./alipay.svg": 26866,
	"./amex.svg": 40173,
	"./diners.svg": 75177,
	"./discover.svg": 81048,
	"./elo.svg": 20918,
	"./hipercard.svg": 2942,
	"./jcb.svg": 98163,
	"./maestro-old.svg": 49412,
	"./maestro.svg": 93453,
	"./mastercard-old.svg": 13336,
	"./mastercard.svg": 17098,
	"./paypal.svg": 2841,
	"./unionpay.svg": 6200,
	"./verve.svg": 28208,
	"./visa.svg": 54516
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74265;